import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import Spinner from 'react-spinkit';

import {
    ASSIGNMENTS__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    DROPBOXES__REQUESTED,
    ROLES__SELF__REQUESTED,
    RUNSCRIPTS__LATEST__REQUESTED,
} from "../constants/actionTypes";
import _ from "lodash";
import { spaceToUnderscore } from "../helpers/helpers";
import NavBar from "../components/NavBar";
import NavLink from "../components/NavLink";
import Card from "../components/bootstrap/Card";
import CardHeader from "../components/bootstrap/CardHeader";
import CardBlock from "../components/bootstrap/CardBlock";
import RunscriptOutputsSection from "../components/RunscriptOutputsSection";
import { AuthorizedComponent } from "react-router-role-authorization";
import { INSTRUCTOR } from "../constants/roles";

const SELF = 'SELF';
const ENROLLMENT = 'ENROLLMENT';

class LatestRunscriptsPage extends AuthorizedComponent{

    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, auth, dispatch, dropboxes, params, roles_self, users } = this.props,
            pageType = params.userId !== undefined ? ENROLLMENT : SELF
        ;

        if (prevProps.roles_self !== roles_self) {
            dispatch({
                type: DROPBOXES__REQUESTED,
            });
        }

        if (prevProps.dropboxes !== dropboxes) {
            if (pageType === ENROLLMENT && !this.hasInstructorRole()) {
                browserHistory.push('/not-found');
            } else {
                dispatch({
                    type: ASSIGNMENTS__REQUESTED
                });

                if (pageType === ENROLLMENT && users.dropbox !== parseInt(params.dropboxId)) {
                    dispatch({
                        type: DROPBOX__USERS__REQUESTED,
                        payload: { dropboxId: parseInt(params.dropboxId) },
                    });
                }
            }
        }

        if (prevProps.assignments !== assignments) {
            if (pageType === ENROLLMENT && !this.hasInstructorRole()) {
                browserHistory.push('/not-found');
            } else {
                const assignment = this.getAssignment(pageType),
                    assignmentId = assignment.id
                ;

                dispatch({
                    type: RUNSCRIPTS__LATEST__REQUESTED,
                    payload: {
                        assignmentId,
                        userId: pageType === ENROLLMENT ? params.userId: auth.id
                    },
                });
            }
        }
    }

    getDropbox(pageType) {
        const { dropboxes, params } = this.props;

        return pageType === ENROLLMENT ?
            _.last(
                _.filter (dropboxes, dropbox => {
                    return dropbox.id === parseInt(params.dropboxId);
                })
            )
        :
             _.last(
                _.filter (dropboxes, dropbox => {
                    return dropbox.name === params.dropboxName;
                })
            )
        ;
    }

    getAssignment(pageType) {
        const { assignments, params } = this.props,
            { assignmentId, assignmentName, dropboxId, dropboxName } = params
        ;

        return pageType === ENROLLMENT ?
            _.last(
                _.filter (
                    assignments,
                    assignment => {
                        return assignment.id === parseInt(assignmentId) && assignment.dropbox.id === parseInt(dropboxId);
                    }
                )
            )
            :
            _.last(
                _.filter (
                    assignments,
                    assignment => {
                        return spaceToUnderscore(assignment.name) === assignmentName && assignment.dropbox.name === dropboxName;
                    }
                )
            )
            ;
    }

    hasInstructorRole() {
        const { params, roles_self } = this.props;

        return _.includes(
            _.flatMap(
                roles_self,
                dropbox_role => {
                    if (dropbox_role.dropbox.id === parseInt(params.dropboxId)) {
                        return dropbox_role.role;
                    }
                }),
            INSTRUCTOR
        );
    }

    render() {
        const { sendingRequest, inProgress } = this.props.request,
            isLoading = (
                _.includes(inProgress, 'assignments.doRequestAssignments') ||
                _.includes(inProgress, 'dropboxes.doRequestDropboxes') ||
                _.includes(inProgress, 'roles.doRequestRolesSelf') ||
                _.includes(inProgress, 'runscript.doRequestLatestRunscripts') ||
                _.includes(inProgress, 'users.doRequestDropboxUsers')
            ),
            { auth, params, users } = this.props,
            user = users[params.userId],
            pageType = params.userId !== undefined ? ENROLLMENT : SELF
        ;

        if (sendingRequest && isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const dropbox = this.getDropbox(pageType),
            assignment = this.getAssignment(pageType)
        ;

        return auth && assignment && dropbox && (pageType === SELF || pageType === ENROLLMENT && user)
        ?
            <div className="col-md-12">
                <div className={"action-links"}>
                    <NavBar
                        className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                    >
                        <NavLink
                            to={
                                pageType === ENROLLMENT ?
                                    `/dropboxes/${dropbox.id}/users/${params.userId}/assignments/${assignment.id}`
                                :
                                    `/${dropbox.name}/${spaceToUnderscore(assignment.name)}`
                            }
                            className="btn btn-outline-primary btn-md"
                            side="left"
                            display
                            key="exit"
                        >
                            {   pageType === ENROLLMENT ?
                                    `Exit To Files for ${user.first_name} ${user.last_name} (${user.username}) `
                                :
                                    `Exit To Assignment `
                            }
                            <i className={"fa fa-chevron-circle-left"}/>
                        </NavLink>
                    </NavBar>
                </div>
                <h3>{dropbox.name}</h3>
                <Card>
                    <CardHeader className="bg-primary">Latest Check Submitted Files</CardHeader>
                    <CardBlock>
                        <h5>Assignment: {assignment.name}</h5>
                        <div
                            id="collapseOne"
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby="headingOne"
                        >
                            <CardBlock>
                                <Card>
                                    <CardHeader>
                                        Runscript Outputs
                                    </CardHeader>
                                    <RunscriptOutputsSection
                                        assignment={assignment}
                                        user={{id: pageType === ENROLLMENT ? params.userId : auth.id}}
                                        className="group-form"
                                        runscripts={null}
                                    />
                                </Card>
                            </CardBlock>
                        </div>
                    </CardBlock>
                </Card>
            </div>
        : null;
    }
}

LatestRunscriptsPage.propTypes = {
    auth: PropTypes.object.isRequired,
    assignments: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,

};

function mapStateToProps(state) {
    const { auth, assignments, dropboxes, request, roles_self, users } = state;

    return { auth, assignments, dropboxes, request, roles_self, users };
}

export default connect(mapStateToProps)(withRouter(LatestRunscriptsPage));



/** WEBPACK FOOTER **
 ** ./src/containers/InstructorLatestRunscriptsPage.js
 **/